import React, { useState, useEffect } from 'react';
import { Typography, Grid, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import EstudanteCard from '../../components/Estudantes/EstudanteCard';
import { listarEstudantes } from '../../services/estudanteService';

const ListaEstudantesPage = () => {
  const [estudantes, setEstudantes] = useState([]);

  useEffect(() => {
    const fetchEstudantes = async () => {
      try {
        const data = await listarEstudantes();
        setEstudantes(data);
      } catch (error) {
        console.error('Erro ao buscar estudantes:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    };

    fetchEstudantes();
  }, []);

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Estudantes
      </Typography>
      <Button
        component={Link}
        to="/estudantes/criar"
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
      >
        Adicionar Novo Estudante
      </Button>
      <Grid container spacing={3}>
        {estudantes.map((estudante) => (
          <Grid item key={estudante.id} xs={12} sm={6} md={4}>
            <EstudanteCard estudante={estudante} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ListaEstudantesPage;